module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.$route.query.t || !(_vm.$route.query.t == _vm.headType.wxShare)) ? _c('div', {
    staticClass: "header-all"
  }, [_c('div', {
    staticClass: "banner-contain"
  }, [_c('v-total', {
    attrs: {
      "type": _vm.type
    }
  })], 1), _vm._v(" "), _c('v-classHead', {
    attrs: {
      "type": _vm.type
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "share-main",
    style: (_vm.hight)
  }, [_c('div', {
    class: _vm.css
  }, [_c('img', {
    attrs: {
      "src": _vm.taoke.Pic
    }
  })]), _vm._v(" "), (!_vm.$route.query.t || !(_vm.$route.query.t == _vm.headType.wxShare)) ? _c('div', [_c('div', {
    staticClass: "share-desc"
  }, [_vm._v("\n        " + _vm._s(_vm.taoke.D_title) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "share-main-body"
  }, [_c('div', {
    staticClass: "share-main-body-left"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("\n                ¥"), _c('span', {
    staticClass: "share-price"
  }, [_vm._v("\n              " + _vm._s(_vm.taoke.Price) + "\n            ")]), _vm._v(" "), _c('span', {
    staticClass: "share-price-desc"
  }, [_vm._v("\n              " + _vm._s(_vm.quanDesc) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('img', {
    attrs: {
      "src": _vm.showImg()
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "share-main-body-right"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowQuan),
      expression: "isShowQuan"
    }],
    staticClass: "share-quan"
  }, [_vm._v(_vm._s(_vm._f("subPrice")(_vm.taoke.Quan_price)) + "元券")]), _vm._v(" "), _c('span', {
    staticClass: "share-num"
  }, [_vm._v(_vm._s(_vm.taoke.Sales_num) + "笔成交")])])]), _vm._v(" "), _c('div', {
    staticClass: "share-main-foot"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.public.gotoDetail(_vm.taoke, _vm.$route.query.t)
      }
    }
  }, [_vm._v("立即购买")])])]) : _c('div', [_c('div', {
    staticClass: "wx-main-body"
  }, [_c('div', {
    staticClass: "wx-main-body-left"
  }, [_c('div', {
    staticClass: "wx-main-body-left-title"
  }, [_vm._v("\n              " + _vm._s(_vm.taoke.D_title) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "wx-main-body-left-quan"
  }, [_c('div', {
    staticClass: "wx-left"
  }, [_vm._v("\n                ¥"), _c('span', {
    staticClass: "wx-price"
  }, [_vm._v("\n                " + _vm._s(_vm.taoke.Price) + "\n              ")]), _vm._v(" "), _c('span', {
    staticClass: "wx-price-desc"
  }, [_vm._v("\n                " + _vm._s(_vm.quanDesc) + "\n             ")])]), _vm._v(" "), _c('div', {
    staticClass: "wx-right"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowQuan),
      expression: "isShowQuan"
    }],
    staticClass: "wx-quan"
  }, [_vm._v(_vm._s(_vm._f("subPrice")(_vm.taoke.Quan_price)) + "元券")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wx-main-body-left-n"
  }, [_c('img', {
    attrs: {
      "src": _vm.showImg()
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "wx-num"
  }, [_vm._v(_vm._s(_vm.taoke.Sales_num) + "笔成交")])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), (!_vm.$route.query.t || !(_vm.$route.query.t == _vm.headType.wxShare)) ? _c('div', {
    staticClass: "share-foot"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require('../../static/img/tuijian.jpg')
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flower-deco"
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), (_vm.isShowBody) ? _c('v-body', {
    attrs: {
      "type": _vm.type,
      "params": "",
      "item": _vm.taoke
    }
  }) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wx-main-body-right"
  }, [_c('canvas', {
    attrs: {
      "id": "qr"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wx-main-body-right-text"
  }, [_vm._v("长按\"识别图中二维码\"")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wx-main-foot"
  }, [_c('span', [_vm._v("扫码领券，才省钱！")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "more-products"
  }, [_c('span', [_vm._v("Top100小编推荐，超值包邮")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c9e9990a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Share.vue
// module id = 218
// module chunks = 2